export const createProjectPath = (projectId: string) => `/project/${projectId}`;
